module.exports = __webpack_public_path__ + "img/bell.86facacc.svg";